import NoiseCanvas from './NoiseCanvas'

interface ClientAuthLayoutProps {
  children: React.ReactNode
}

export default function ClientAuthLayout({ children }: ClientAuthLayoutProps) {
  return (
    <main className="min-h-screen bg-[#F5F3F0] lg:grid lg:grid-cols-[minmax(0,1.12fr)_minmax(420px,.88fr)]">
      <section
        className="relative hidden overflow-hidden bg-[#1A0F0E] px-12 py-12 lg:flex lg:flex-col lg:justify-between"
        style={{ isolation: 'isolate' }}
      >
        <NoiseCanvas />
        <div
          aria-hidden="true"
          className="absolute inset-0 pointer-events-none"
          style={{
            backgroundImage: 'url(/images/topo-pattern-slide.png)',
            backgroundPosition: 'center bottom',
            backgroundSize: 'cover',
            mixBlendMode: 'lighten',
            opacity: 0.25,
          }}
        />
        <img
          src="/images/pinnacle-logo-darkbg.png"
          alt="Pinnacle Business Guides"
          className="relative z-10 w-[280px]"
        />
        <div className="relative z-10 max-w-xl">
          <p
            className="mb-5 text-xs font-bold uppercase tracking-[0.2em] text-text-on-dark"
          >
            Pinnacle Navigator
          </p>
          <h1
            className="font-sans text-[clamp(2.8rem,5vw,4.4rem)] font-extralight uppercase leading-[1.03] tracking-[0.08em] text-text-on-dark"
          >
            Keep the whole team moving forward.
          </h1>
        </div>
        <p className="relative z-10 text-xs text-text-on-dark">
          &copy; {new Date().getFullYear()} Pinnacle Business Guides
        </p>
      </section>

      <section className="flex min-h-[100dvh] flex-col bg-[#F5F3F0]">
        <header className="flex items-center justify-center bg-[#1A0F0E] px-6 py-7 lg:hidden">
          <img
            src="/images/pinnacle-logo-darkbg.png"
            alt="Pinnacle Business Guides"
            className="w-[220px]"
          />
        </header>
        <div className="flex flex-1 items-center justify-center px-6 py-12 sm:px-10 lg:px-12">
          <div className="w-full max-w-[400px]">
            <div className="mb-9 hidden justify-center lg:flex">
              <img
                src="/images/pinnacle-logo-color.png"
                alt="Pinnacle Business Guides"
                className="w-[260px]"
              />
            </div>
            {children}
          </div>
        </div>
        <p className="px-6 pb-7 text-center text-xs text-text-primary lg:hidden">
          &copy; {new Date().getFullYear()} Pinnacle Business Guides
        </p>
      </section>
    </main>
  )
}